import React, { useState, useEffect } from 'react';
import Sidebar from '../components/SideBar';
import BarraPesquisaEmpreendimentos from '../components/empreendimentos/BarraPesquisaEmpreendimentos';
import FiltrosLateraisEmpreendimentos from '../components/empreendimentos/FiltrosLateraisEmpreendimentos';
import ListaEmpreendimentos from '../components/empreendimentos/ListaEmpreendimentos';
import PaginacaoEmpreendimentos from '../components/empreendimentos/PaginacaoEmpreendimentos';
import '../styles/empreendimentosStyle/Empreendimentos.css';
import type { Filtros } from '../components/empreendimentos/Filtros';
import { getEmpreendimentosPaginados, FiltrosEmpreendimentos } from '../API/empreendimentosService';

const ITENS_POR_PAGINA = 10;

export default function Empreendimentos() {
  const [filtros, setFiltros] = useState<Filtros>({
    pesquisa: '',
    estado: '',
    municipio: [],
    bairro: [],
    precoMin: undefined,
    precoMax: undefined,
    quartos: [],
    suites: [],
    metragemMin: undefined,
    metragemMax: undefined,
    tipoSelecionado: [],
    faseSelecionada: [],
    segmentoSelecionado: [],
  });

  const [empreendimentos, setEmpreendimentos] = useState<any[]>([]);
  const [pagina, setPagina] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);

  // --- Converte filtros para formato aceito pela API ---
  const converterFiltros = (f: Filtros): FiltrosEmpreendimentos => ({
    precoMin: f.precoMin,
    precoMax: f.precoMax,
    areaMin: f.metragemMin,
    areaMax: f.metragemMax,
    quartos: f.quartos,
    suites: f.suites,
    municipio: f.municipio,
    bairro: f.bairro,
  });

  // --- Busca empreendimentos ao mudar filtros ou página ---
  useEffect(() => {
    const fetchEmpreendimentos = async () => {
      try {
        const filtrosApi = converterFiltros(filtros);
        const resposta = await getEmpreendimentosPaginados(filtrosApi, pagina, ITENS_POR_PAGINA);
        setEmpreendimentos(resposta.results);
        setTotalPaginas(Math.ceil(resposta.count / ITENS_POR_PAGINA));
      } catch (err) {
        console.error('Erro ao buscar empreendimentos:', err);
      }
    };

    fetchEmpreendimentos();
  }, [filtros, pagina]);

  // --- Atualiza filtros ---
  const handleFiltrosChange = (novosFiltros: Partial<Filtros>) => {
    setFiltros(prev => ({ ...prev, ...novosFiltros }));
    setPagina(1); // resetar paginação ao alterar filtros
  };

  return (
    <div className="empreendimentos-container">
      <Sidebar />
      <div className="empreendimentos-content">
        <BarraPesquisaEmpreendimentos
          pesquisa={filtros.pesquisa}
          onPesquisaChange={novaPesquisa => handleFiltrosChange({ pesquisa: novaPesquisa })}
        />
        <div className="empreendimentos-main">
          <FiltrosLateraisEmpreendimentos
            filtros={filtros}
            onChange={handleFiltrosChange}
            setEmpreendimentos={setEmpreendimentos} // opcional
          />
          <div className="empreendimentos-listagem">
            <ListaEmpreendimentos filtros={filtros} empreendimentos={empreendimentos} />
            <PaginacaoEmpreendimentos
              pagina={pagina}
              totalPaginas={totalPaginas}
              onPageChange={setPagina}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
